import { Children, isValidElement } from "react"
import { Typography, type TypographyColor } from "@octopus-energy/coral/atoms"
import { type RenderOptionsProps } from "storyblok-rich-text-react-renderer-ts"
import { StoryblokImage } from "../components/StoryblokImage"

export function getNodeResolvers(color?: TypographyColor): RenderOptionsProps["nodeResolvers"] {
    return {
        heading: (children, { level }) => (
            <Typography
                color={color}
                textStyle={`h${level}`}
            >
                {children}
            </Typography>
        ),
        paragraph: (children) => {
            const hasImageChild = Children.toArray(children).some(
                (child) => isValidElement(child) && child.type === StoryblokImage
            )

            return (
                <Typography
                    color={color ?? "inherit"}
                    component={hasImageChild ? "div" : "p"}
                >
                    {children}
                </Typography>
            )
        },
        image: (_, { alt, src, title }) => {
            if (!alt || !src) return null

            return (
                <StoryblokImage
                    src={src}
                    alt={alt}
                    width={0}
                    height={0}
                    caption={title}
                    sizes="100vw"
                    style={{ maxWidth: "min(100%, 600px)", width: "100%", height: "auto" }}
                />
            )
        },
    }
}
